import {
  EmptyStateNoResultIllustration,
  EmptyStateProps,
} from '@ardoq/status-ui';
import { OnButtonClick } from './types';
import { PrimaryButton } from '@ardoq/button';
import { t, type I18nLocale } from '@ardoq/i18n';

export type NoViewpointBubbleFieldsSelectedComponentArgs = {
  onBubbleChartSettings: OnButtonClick;
  i18nLocale: I18nLocale;
};

export const noViewpointBubbleFieldsSelectedComponent = ({
  onBubbleChartSettings,
  i18nLocale,
}: NoViewpointBubbleFieldsSelectedComponentArgs): EmptyStateProps => ({
  media: <EmptyStateNoResultIllustration />,
  title: t(
    i18nLocale,
    'tabview:graphViews.emptyStateLayout.noViewpointBubbleFieldsSelectedComponent.title',
    'No value in the Bubble Chart fields for the selected component type'
  ),
  description: (
    <>
      {t(
        i18nLocale,
        'tabview:graphViews.emptyStateLayout.noViewpointBubbleFieldsSelectedComponent.description1',
        'The selected component type has no value in the bubble size, X or Y-axis fields.'
      )}
      <br />
      <br />
      {t(
        i18nLocale,
        'tabview:graphViews.emptyStateLayout.noViewpointBubbleFieldsSelectedComponent.description2',
        'Change your Bubble chart settings to select a different component type, select different fields or add values to the selected fields.'
      )}
    </>
  ),
  children: (
    <PrimaryButton onClick={onBubbleChartSettings}>
      {t(
        i18nLocale,
        'tabview:graphViews.emptyStateLayout.noViewpointBubbleFieldsSelectedComponent.bubbleChartSettings',
        'Bubble chart settings'
      )}
    </PrimaryButton>
  ),
});
